module.exports = "https://static.im-cdn.com/mjc/storefront/Melody/static/media/Arrow.ea1188d9.svg";